var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundtrack2025TxtImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 534,
    height: 161,
    viewBox: "0 0 534 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2065_80204)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2065_80204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.346 21.1845V11.1411H156.922C156.867 11.2326 156.812 11.324 156.739 11.4155C154.761 14.0132 152.435 16.5927 150.109 19.1904L148.443 17.8001C150.586 15.3487 152.746 12.9339 154.596 10.4825C155.145 9.76906 155.365 8.94584 155.365 7.8482V4.40895H149.139V2.25027H157.764V7.77503C157.764 8.17749 157.746 8.57996 157.691 8.92754H160.328V1.44534H162.764V21.1845H160.328H160.346ZM165.236 21.7699V1.20752H167.69V21.7699H165.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.363 11.946C171.755 11.946 169.118 9.71415 169.118 6.49443C169.118 3.2747 171.755 1.04285 175.363 1.04285C178.97 1.04285 181.607 3.2747 181.607 6.49443C181.607 9.71415 178.97 11.946 175.363 11.946ZM171.407 21.6052V13.629H187.193V21.6052H171.407ZM175.363 3.20153C173.074 3.20153 171.572 4.50039 171.572 6.49443C171.572 8.48846 173.074 9.78733 175.363 9.78733C177.652 9.78733 179.153 8.48846 179.153 6.49443C179.153 4.50039 177.652 3.20153 175.363 3.20153ZM184.739 15.7877H173.861V19.4282H184.739V15.7877ZM184.739 12.5863V1.20749H187.193V12.6046H184.739V12.5863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.987 12.6228V10.4641H209.296V12.6228H188.987ZM195.25 8.96405C192.375 8.96405 190.379 7.39077 190.379 5.03086C190.379 2.67095 192.375 1.11597 195.25 1.11597H203.015C205.89 1.11597 207.886 2.67095 207.886 5.03086C207.886 7.39077 205.89 8.96405 203.015 8.96405H195.25ZM190.91 21.6051V14.5071H207.337V21.6051H190.91ZM195.47 3.20147C193.749 3.20147 192.833 3.87835 192.833 5.03086C192.833 6.18338 193.749 6.89684 195.47 6.89684H202.814C204.535 6.89684 205.451 6.18338 205.451 5.03086C205.451 3.87835 204.535 3.20147 202.814 3.20147H195.47ZM204.883 16.5743H193.364V19.5379H204.883V16.5743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.669 12.3485C212.061 12.3485 209.516 9.97031 209.516 6.75058C209.516 3.53086 212.061 1.15265 215.669 1.15265C219.277 1.15265 221.822 3.53086 221.822 6.75058C221.822 9.97031 219.277 12.3485 215.669 12.3485ZM224.899 21.843V16.2634H211.713V14.1047H227.352V21.843H224.899ZM215.669 3.27474C213.435 3.27474 211.97 4.70166 211.97 6.75058C211.97 8.7995 213.435 10.2264 215.669 10.2264C217.903 10.2264 219.368 8.7995 219.368 6.75058C219.368 4.70166 217.903 3.27474 215.669 3.27474ZM224.899 13.062V1.20753H227.352V5.67124H230.118V7.8848H227.352V13.062H224.899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.42 3.91502H235.978V1.73804H246.856V6.23834C246.856 7.88479 246.343 8.65314 244.859 9.29342C242.131 10.4642 238.908 11.7448 235.923 12.8424L234.989 10.9582C237.864 9.86053 241.069 8.59825 243.449 7.50062C244.164 7.17133 244.42 6.78716 244.42 5.83588V3.91502ZM242.131 21.7516C239.182 21.7516 237.058 20.1051 237.058 17.544C237.058 14.9828 239.182 13.3364 242.131 13.3364H248.87C251.818 13.3364 253.943 14.9828 253.943 17.544C253.943 20.1051 251.818 21.7516 248.87 21.7516H242.131ZM242.277 15.4768C240.648 15.4768 239.53 16.1902 239.53 17.5257C239.53 18.8611 240.666 19.5746 242.277 19.5746H248.723C250.353 19.5746 251.489 18.8611 251.489 17.5257C251.489 16.1902 250.353 15.4768 248.723 15.4768H242.277ZM250.939 12.6595V10.3728H246.819V8.23238H250.939V5.57976H247.789V3.43938H250.939V1.20752H253.393V12.6595H250.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.431 16.2085V10.9399H266.633C265.516 12.1473 263.905 12.8973 261.964 12.8973C258.356 12.8973 255.81 10.2996 255.81 7.07986C255.81 3.86013 258.356 1.2624 261.964 1.2624C263.96 1.2624 265.644 2.06733 266.725 3.32961H271.431V1.20752H273.885V16.2268H271.431V16.2085ZM258.1 21.6052V14.5987H260.553V19.4465H274.38V21.6052H258.1ZM261.964 3.38449C259.729 3.38449 258.264 5.03094 258.264 7.07986C258.264 9.12878 259.729 10.7752 261.964 10.7752C264.198 10.7752 265.663 9.12878 265.663 7.07986C265.663 5.03094 264.198 3.38449 261.964 3.38449ZM271.431 5.56147H267.897C268.043 6.0554 268.117 6.56763 268.117 7.09815C268.117 7.68356 268.025 8.23238 267.879 8.74461H271.431V5.56147Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.705 18.1111V2.23198H285.605V4.39066H279.141V15.9524H286.228V18.1111H276.687H276.705ZM292.912 21.7699V11.0313H290.092V21.1662H287.656V1.44534H290.092V8.83607H292.912V1.20752H295.366V21.7699H292.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.666 19.227V17.1781H302.892V15.1291C299.999 14.7999 298.259 13.2266 298.259 10.8484C298.259 8.15917 300.53 6.49443 304.156 6.49443C307.782 6.49443 310.053 8.15917 310.053 10.8484C310.053 13.2266 308.295 14.7999 305.42 15.1291V17.1781H311.811V19.227H296.703H296.666ZM297.673 5.57973V3.53082H302.911V1.04285H305.365V3.53082H310.602V5.57973H297.692H297.673ZM304.119 8.48846C301.959 8.48846 300.677 9.53121 300.677 10.8484C300.677 12.1655 301.94 13.2083 304.119 13.2083C306.299 13.2083 307.562 12.1655 307.562 10.8484C307.562 9.53121 306.299 8.48846 304.119 8.48846ZM312.708 21.7881V1.20749H315.162V21.8064H312.708V21.7881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3016 19.6294H5.10925V6.87858H14.1924V14.5254H10.2002V12.2753H11.9399V9.12873H7.36172V17.3793H17.0491V3.87838H2.25247V19.6294H0V1.62823H19.3016V19.6294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8235 21.2392L26.2421 11.7447L26.1871 9.78723L33.1093 0L35.783 1.90257L29.575 10.6653L34.9406 17.3975L38.2186 12.1837L34.904 12.4398L34.6293 9.16524L41.2219 8.65301L42.7418 11.1593L36.4972 21.0929L33.8235 21.2392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2331 21.2392L75.8145 11.7447L75.8695 9.78723L68.9656 0L66.2736 1.90257L72.4816 10.6653L67.116 17.3975L63.838 12.1837L67.1709 12.4398L67.4273 9.16524L60.8347 8.65301L59.3148 11.1593L65.5594 21.0929L68.2331 21.2392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.02 0.107889L45.0591 1.513L54.3864 21.1272L57.3472 19.7221L48.02 0.107889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3972 0.0939875L44.6404 19.703L47.5757 21.1605L57.3326 1.55153L54.3972 0.0939875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4388 8.11534L78.7324 10.8189L81.4388 13.5225L84.1451 10.8189L81.4388 8.11534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.926 20.5623H82.4989L90.9777 8.32372L85.1542 3.09166L87.2602 0.73175L95.1713 7.82978L88.5238 17.4158H93.926V20.5623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.908 20.5623H110.481L118.978 8.32372L113.136 3.09166L115.26 0.73175L123.153 7.82978L116.524 17.4158H121.908V20.5623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.165 10.7372L103.481 9.05554L101.798 10.7372L103.481 12.4188L105.165 10.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.375 20.5258L96.4897 10.9032L103.302 0.750061L110.481 10.4458L103.375 20.5258ZM100.152 10.8483L103.357 15.4584L106.763 10.4641L103.43 6.25652L100.152 10.8483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.009 21.0197L128.153 19.6659L132.273 11.0129H126.102V0.274414H136.174V3.43926H129.27V7.84809H137.272L131.009 21.0197Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2065_80204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7909 92.6526V55.854H0V45.2021H43.4949V55.854H27.7041V92.6526H15.8064H15.7909Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.201 92.6527V66.21H62.7116V92.6527H51.1098V43.0688H62.7116V55.7918H78.2688C83.2365 55.7918 86.7871 59.1088 86.7871 64.0765V92.6527H75.1854H75.201Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.089 92.6526C99.1213 92.6526 95.5707 89.3356 95.5707 84.3679V64.0765C95.5707 59.1088 99.1213 55.7917 104.089 55.7917H122.73C127.822 55.7917 131.248 59.2178 131.248 64.3101V70.5859C131.248 75.6783 128.414 78.5125 123.321 78.5125H107.172V82.4836H119.07V80.2878H130.672V84.1343C130.672 89.2266 127.246 92.6526 122.154 92.6526H104.105H104.089ZM119.646 65.9608H107.157V70.1655H119.646V65.9608Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.123 92.6528V76.8619C159.123 71.7696 162.206 68.5149 167.174 67.6272L187.294 64.0766V55.7919H171.55V62.3013H159.714V53.783C159.714 48.6907 163.265 45.1401 168.357 45.1401H190.486C195.579 45.1401 199.129 48.6907 199.129 53.783V64.6061C199.129 69.6984 196.108 72.9531 191.078 73.8408L170.958 77.3914V82.001H198.537V92.6528H159.138H159.123Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.134 70.7729V55.3558H213.861V70.7729H207.103V49.2823H222.94C225.837 49.2823 227.908 51.2134 227.908 54.1099V70.7729H221.149H221.134Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.969 70.7729C235.072 70.7729 233.001 68.7795 233.001 65.8674V54.0944C233.001 51.1978 235.072 49.2668 237.969 49.2668H247.048V41.8541H253.806V70.7729H237.969ZM247.048 55.3402H239.775V64.6839H247.048V55.3402Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.484 92.6528V85.0845L307.034 92.6528H288.58C283.487 92.6528 279.937 89.1022 279.937 84.0099V53.7675C279.937 48.6752 283.487 45.1246 288.58 45.1246H315.676C320.769 45.1246 324.319 48.6752 324.319 53.7675V60.3392H312.484V55.7764H291.772V81.9855H312.484V75.3047H302.782V64.5283H324.319V83.9944C324.319 89.0867 320.769 92.6373 315.676 92.6373H312.484V92.6528Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.556 92.6526L354.142 77.3912L342.727 92.6526H328.524L346.511 68.4524L329.708 45.2021H343.91L354.142 59.5759L364.373 45.2021H378.575L361.897 68.5147L379.759 92.6526H365.556Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.103 92.6528V85.0845L411.652 92.6528H393.198C388.106 92.6528 384.555 89.1022 384.555 84.0099V53.7675C384.555 48.6752 388.106 45.1246 393.198 45.1246H420.295C425.387 45.1246 428.938 48.6752 428.938 53.7675V60.3392H417.103V55.7764H396.391V81.9855H417.103V75.3047H407.401V64.5283H428.938V83.9944C428.938 89.0867 425.387 92.6373 420.295 92.6373H417.103V92.6528Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7909 92.6526V55.854H0V45.2021H43.4949V55.854H27.7041V92.6526H15.8064H15.7909Z",
    fill: "url(#paint0_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.201 92.6527V66.21H62.7116V92.6527H51.1098V43.0688H62.7116V55.7918H78.2688C83.2365 55.7918 86.7871 59.1088 86.7871 64.0765V92.6527H75.1854H75.201Z",
    fill: "url(#paint1_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.089 92.6526C99.1213 92.6526 95.5707 89.3356 95.5707 84.3679V64.0765C95.5707 59.1088 99.1213 55.7917 104.089 55.7917H122.73C127.822 55.7917 131.248 59.2178 131.248 64.3101V70.5859C131.248 75.6783 128.414 78.5125 123.321 78.5125H107.172V82.4836H119.07V80.2878H130.672V84.1343C130.672 89.2266 127.246 92.6526 122.154 92.6526H104.105H104.089ZM119.646 65.9608H107.157V70.1655H119.646V65.9608Z",
    fill: "url(#paint2_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.123 92.6528V76.8619C159.123 71.7696 162.206 68.5149 167.174 67.6272L187.294 64.0766V55.7919H171.55V62.3013H159.714V53.783C159.714 48.6907 163.265 45.1401 168.357 45.1401H190.486C195.579 45.1401 199.129 48.6907 199.129 53.783V64.6061C199.129 69.6984 196.108 72.9531 191.078 73.8408L170.958 77.3914V82.001H198.537V92.6528H159.138H159.123Z",
    fill: "url(#paint3_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.134 70.7729V55.3558H213.861V70.7729H207.103V49.2823H222.94C225.837 49.2823 227.908 51.2134 227.908 54.1099V70.7729H221.149H221.134Z",
    fill: "url(#paint4_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.969 70.7729C235.072 70.7729 233.001 68.7795 233.001 65.8674V54.0944C233.001 51.1978 235.072 49.2668 237.969 49.2668H247.048V41.8541H253.806V70.7729H237.969ZM247.048 55.3402H239.775V64.6839H247.048V55.3402Z",
    fill: "url(#paint5_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.484 92.6528V85.0845L307.034 92.6528H288.58C283.487 92.6528 279.937 89.1022 279.937 84.0099V53.7675C279.937 48.6752 283.487 45.1246 288.58 45.1246H315.676C320.769 45.1246 324.319 48.6752 324.319 53.7675V60.3392H312.484V55.7764H291.772V81.9855H312.484V75.3047H302.782V64.5283H324.319V83.9944C324.319 89.0867 320.769 92.6373 315.676 92.6373H312.484V92.6528Z",
    fill: "url(#paint6_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.556 92.6526L354.142 77.3912L342.727 92.6526H328.524L346.511 68.4524L329.708 45.2021H343.91L354.142 59.5759L364.373 45.2021H378.575L361.897 68.5147L379.759 92.6526H365.556Z",
    fill: "url(#paint7_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.103 92.6528V85.0845L411.652 92.6528H393.198C388.106 92.6528 384.555 89.1022 384.555 84.0099V53.7675C384.555 48.6752 388.106 45.1246 393.198 45.1246H420.295C425.387 45.1246 428.938 48.6752 428.938 53.7675V60.3392H417.103V55.7764H396.391V81.9855H417.103V75.3047H407.401V64.5283H428.938V83.9944C428.938 89.0867 425.387 92.6373 420.295 92.6373H417.103V92.6528Z",
    fill: "url(#paint8_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64292 160.192C3.5506 160.192 0 156.641 0 151.549V144.09H11.8353V149.54H31.3637V140.664H8.64292C3.5506 140.664 0.591766 137.705 0.591766 132.612V121.307C0.591766 116.214 4.14237 112.664 9.23469 112.664H34.2602C39.3525 112.664 42.9031 116.214 42.9031 121.307V127.816H31.0678V123.316H12.4271V130.884H35.1479C40.2402 130.884 43.199 133.843 43.199 138.935V151.533C43.199 156.626 39.6484 160.176 34.5561 160.176H8.64292V160.192Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.31 160.192C56.2177 160.192 52.6671 156.641 52.6671 151.549V121.307C52.6671 116.214 56.2177 112.664 61.31 112.664H87.2232C92.3155 112.664 95.8661 116.214 95.8661 121.307V151.549C95.8661 156.641 92.3155 160.192 87.2232 160.192H61.31ZM84.0307 123.331H64.5024V149.54H84.0307V123.331Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.086 160.192C108.994 160.192 105.443 156.641 105.443 151.549V112.679H117.279V149.54H135.624V112.679H147.459V151.549C147.459 156.641 143.908 160.192 138.816 160.192H114.086Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.173 160.192L175.693 140.726C173.497 136.646 172.142 134.154 170.071 130.136V160.192H157.177V112.679H171.083L184.274 136.879C185.815 139.48 186.765 141.193 188.229 143.981V112.679H200.064V160.192H186.158H186.173Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.906 160.192V112.679H244.275C250.193 112.679 254.335 116.822 254.335 122.739V150.132C254.335 156.05 250.193 160.192 244.275 160.192H209.906ZM242.5 123.456H221.726V149.556H242.5V123.456Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.13 160.192V123.394H281.339V112.742H324.834V123.394H309.043V160.192H297.145H297.13Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.984 160.192L355.341 145.164H344.517V160.192H332.682V112.679H365.697C370.789 112.679 374.339 116.23 374.339 121.322V136.521C374.339 140.664 371.972 143.747 368.422 144.806L377.89 160.192H363.984ZM362.504 123.331H344.517V134.512H362.504V123.331Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.071 160.192L413.817 149.54H396.842L393.292 160.192H380.335L396.126 112.679H415.358L430.028 160.192H417.071ZM408.319 131.195C407.494 128.237 406.42 124.748 405.828 121.789C405.111 124.748 403.99 128.237 403.04 131.195L400.144 139.714H410.858L408.319 131.195Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.059 160.192C438.967 160.192 435.417 156.641 435.417 151.549V121.307C435.417 116.214 438.967 112.664 444.059 112.664H469.91C475.003 112.664 478.553 116.214 478.553 121.307V130.012H466.718V123.331H447.252V149.54H466.718V141.847H478.553V151.549C478.553 156.641 475.003 160.192 469.91 160.192H444.059Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.501 160.192L504.482 141.847L499.685 146.223V160.192H487.912V112.679H499.685V130.9L516.909 112.679H531.999L513.062 133.033L533.837 160.192H517.501Z",
    stroke: "white",
    strokeWidth: 2.95845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64292 160.192C3.5506 160.192 0 156.641 0 151.549V144.09H11.8353V149.54H31.3637V140.664H8.64292C3.5506 140.664 0.591766 137.705 0.591766 132.612V121.307C0.591766 116.214 4.14237 112.664 9.23468 112.664H34.2602C39.3525 112.664 42.9031 116.214 42.9031 121.307V127.816H31.0678V123.316H12.4271V130.884H35.1479C40.2402 130.884 43.199 133.843 43.199 138.935V151.533C43.199 156.626 39.6484 160.176 34.5561 160.176H8.64292V160.192Z",
    fill: "url(#paint9_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.31 160.192C56.2177 160.192 52.6671 156.641 52.6671 151.549V121.307C52.6671 116.214 56.2177 112.664 61.31 112.664H87.2232C92.3155 112.664 95.8661 116.214 95.8661 121.307V151.549C95.8661 156.641 92.3155 160.192 87.2232 160.192H61.31ZM84.0307 123.331H64.5024V149.54H84.0307V123.331Z",
    fill: "url(#paint10_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.086 160.192C108.994 160.192 105.443 156.641 105.443 151.549V112.679H117.279V149.54H135.624V112.679H147.459V151.549C147.459 156.641 143.908 160.192 138.816 160.192H114.086Z",
    fill: "url(#paint11_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.173 160.192L175.693 140.726C173.497 136.646 172.142 134.154 170.071 130.136V160.192H157.177V112.679H171.083L184.274 136.879C185.815 139.48 186.765 141.193 188.229 143.981V112.679H200.064V160.192H186.158H186.173Z",
    fill: "url(#paint12_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.906 160.192V112.679H244.275C250.193 112.679 254.335 116.822 254.335 122.739V150.132C254.335 156.05 250.193 160.192 244.275 160.192H209.906ZM242.5 123.456H221.726V149.556H242.5V123.456Z",
    fill: "url(#paint13_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.13 160.192V123.394H281.339V112.742H324.834V123.394H309.043V160.192H297.145H297.13Z",
    fill: "url(#paint14_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.984 160.192L355.341 145.164H344.517V160.192H332.682V112.679H365.697C370.789 112.679 374.339 116.23 374.339 121.322V136.521C374.339 140.664 371.972 143.747 368.422 144.806L377.89 160.192H363.984ZM362.504 123.331H344.517V134.512H362.504V123.331Z",
    fill: "url(#paint15_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.071 160.192L413.817 149.54H396.842L393.292 160.192H380.335L396.126 112.679H415.358L430.028 160.192H417.071ZM408.319 131.195C407.494 128.237 406.42 124.748 405.828 121.789C405.111 124.748 403.99 128.237 403.04 131.195L400.144 139.714H410.858L408.319 131.195Z",
    fill: "url(#paint16_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.059 160.192C438.967 160.192 435.417 156.641 435.417 151.549V121.307C435.417 116.214 438.967 112.664 444.059 112.664H469.91C475.003 112.664 478.553 116.214 478.553 121.307V130.012H466.718V123.331H447.252V149.54H466.718V141.847H478.553V151.549C478.553 156.641 475.003 160.192 469.91 160.192H444.059Z",
    fill: "url(#paint17_linear_2065_80204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.501 160.192L504.482 141.847L499.685 146.223V160.192H487.912V112.679H499.685V130.9L516.909 112.679H531.999L513.062 133.033L533.837 160.192H517.501Z",
    fill: "url(#paint18_linear_2065_80204)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2065_80204",
    x: -31.0637,
    y: 10.7904,
    width: 595.964,
    height: 180.465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7922
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2065_80204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2065_80204",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2065_80204",
    x1: -49.9888,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2065_80204",
    x1: -49.989,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2065_80204",
    x1: -49.9886,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2065_80204",
    x1: -49.9894,
    y1: 101.031,
    x2: 474.363,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2065_80204",
    x1: -49.9892,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2065_80204",
    x1: -49.9885,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2065_80204",
    x1: -49.9892,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2065_80204",
    x1: -49.9889,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2065_80204",
    x1: -49.9888,
    y1: 101.031,
    x2: 474.364,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2065_80204",
    x1: 0,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2065_80204",
    x1: -0.00025763,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2065_80204",
    x1: -0.000135336,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2065_80204",
    x1: 0.000253919,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2065_80204",
    x1: -0.0000239193,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2065_80204",
    x1: 0.000339919,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2065_80204",
    x1: -0.0000197415,
    y1: 101.031,
    x2: 524.352,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2065_80204",
    x1: -0.000159972,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2065_80204",
    x1: -0.0000278643,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2065_80204",
    x1: 0.000193096,
    y1: 101.031,
    x2: 524.353,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2065_80204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 534,
    height: 160.192,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2065_80204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315,
    height: 21.8542,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundtrack2025TxtImg);
export default __webpack_public_path__ + "static/media/soundtrack2025TxtImg.763db4ff58c147bb8637fc65f6a73b84.svg";
export { ForwardRef as ReactComponent };